import { MouseEventHandler, PropsWithChildren } from "react";
import { TextCta } from "../ctas";
import { EventElementTypes } from "../types";

type SearchResultsContainerProps = PropsWithChildren<{
  total: number;
  query?: string;
  hasMore?: boolean;
  onShowMoreClick?: MouseEventHandler<EventElementTypes>;
}>;

export function SearchResultsContainer({
  total,
  hasMore,
  onShowMoreClick,
  query,
  children,
}: SearchResultsContainerProps) {
  const getTotalResultsElement = () => {
    if (query?.length) {
      return (
        <>
          {total} results for{" "}
          <span className="normal-case text-tertiary_text">"{query}"</span>{" "}
        </>
      );
    } else {
      return <>{total} results</>;
    }
  };

  return (
    <div
      className="global-container w-full flex-grow"
      data-content-type="searchResults"
      data-search-query={query}
    >
      <p className="eyebrows my-6">{getTotalResultsElement()}</p>
      {children}
      <div className="flex-center py-20">
        {hasMore ? (
          <TextCta
            label={"show more"}
            kind={"black"}
            onClick={onShowMoreClick}
          />
        ) : (
          <TextCta label={"end of list"} kind={"black"} disabled />
        )}
      </div>
    </div>
  );
}
